<template>
  <a-radio-group :value="value" buttonStyle="solid" @change="onChange" class="info-switcher">
    <a-radio-button
      v-a11y-tab
      v-for="option in options"
      :key="option.value"
      :value="option.value"
    >{{ option.label }}</a-radio-button>
  </a-radio-group>
</template>

<script>
import { ROUTER_PATHS } from '@/router/constants';

export default {
  data() {
    return {
      value: this.$router.currentRoute.path,
    };
  },
  computed: {
    options() {
      return [
        {
          label: this.$t('targeting.info'),
          value: ROUTER_PATHS.TARGETING_INFO,
        },
        {
          label: this.$t('private.info'),
          value: ROUTER_PATHS.PRIVATE_INFO,
        },
        {
          label: this.$t('digital.fingerprint'),
          value: ROUTER_PATHS.DIGITAL_FINGERPRINT,
        },
      ];
    },
  },
  watch: {
    $route(to) {
      this.value = to.path;
    },
  },
  methods: {
    onChange(e) {
      this.$router.push(e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';

.info-switcher {
  .ant-radio-button-wrapper {
    height: 40px;
    line-height: 40px;
    font-size: $font-size-large;
    color: $primary;
    border-color: $primary;
    letter-spacing: 0.9px;
    text-transform: capitalize;
  }
  .ant-radio-button-wrapper-checked {
    color: $white;
  }
}
</style>
